import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { DollarSign, TrendingUp, Zap, PieChart, Crown } from "lucide-react";
import { dashboardService } from "../../services/api";

import StatCard from "../../components/StatCard/StatCard";
import { StatCardPercentage } from "../../components/StatCard/StatCardPercentage.jsx";
import RevenueChart from "../../components/Charts/RevenueChart";
import MilestoneCard from "../../components/MilestoneCard/MilestoneCard";
import "./index.css";
import FiltersSection from "../../components/Filter/Filter";
// import { useAuth } from "../../hooks/useAuth";
import { useAuth } from "../../context/AuthProvider.jsx";
import { fmtCurrencyBR, fmtNumberBR } from "../../utils/formatBrl";
import { SkeletonCard, SkeletonChart, SkeletonMilestone } from "../../components/SkeletonLoading/SkeletonLoading";
import { RankingItem } from "../../components/StatCard/RankingItem.jsx";
import { fmtDate } from "../utils/dateUtils/fmtDate.js";
import LogsSection from "../../components/LogsSection/LogsSection.jsx";
import BotStartsMiniChart from "../../components/Charts/BotStartsMiniChart";
import Gauge from "../../components/Charts/GaugeChart.jsx";
import { getVisibleBots } from "../../utils/bots";



export default function Dashboard() {
  // Removido useSearchParams, não usa mais URL


  const { user } = useAuth();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sectionsLoaded, setSectionsLoaded] = useState({
    stats: false,
    chart: false,
    ranking: false,
    logs: false
  });

  const visibleBots = getVisibleBots(user?.bots);




  // Remove o useEffect de busca automática, só busca quando filtro é aplicado
  useEffect(() => { }, []);




  function handleApplyFilters(filters) {
    setLoading(true);
    setSectionsLoaded({
      stats: false,
      chart: false,
      ranking: false,
      logs: false
    });
    // Monta objeto com as chaves esperadas pelo backend
    const body = {
      start_date: filters.startDate,
      end_date: filters.endDate,
    };

    if (filters.botIds && filters.botIds.length > 0) body.bot_ids = filters.botIds;
    else if (filters.botId) body.bot_id = filters.botId;
    if (filters.gatewayId) body.gateway_id = filters.gatewayId;

    console.log("[Dashboard] Applying filters with body:", body);
    dashboardService.getStats(body)
      .then(res => {
        setData(res.data);
        console.log("[Dashboard] Data loaded:", res.data);
        setTimeout(() => setSectionsLoaded(prev => ({ ...prev, stats: true })), 100);
        setTimeout(() => setSectionsLoaded(prev => ({ ...prev, chart: true })), 300);
        setTimeout(() => setSectionsLoaded(prev => ({ ...prev, ranking: true })), 500);
        setTimeout(() => setSectionsLoaded(prev => ({ ...prev, logs: true })), 700);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }







  const { stats, chart_data, period_label } = data || {};
  // Request falhou (ex.: backend reiniciando) → mantém o skeleton em vez de quebrar a tela
  const showSkeleton = loading || !stats;








  return (
    <>
      <main className="page">
        <div className="page-header-with-filters">
          <div className="page-header-content">
            <h1 className="title">Bem-vindo de volta, {user?.username} 👋</h1>
            <p>Monitore seus bots e métricas do Telegram</p>
          </div>
        </div>

        <FiltersSection
          onApplyFilters={handleApplyFilters}
          gateway={user?.gateways || []}
          bots={visibleBots}
          enableBotMultiSelect={true}
        />


        {/* Stats */}
        <div className="stats-grid" >
          {showSkeleton ? (
            <>
              {Array(4).fill(0).map((_, i) => <SkeletonCard key={i} />)}
            </>
          ) : (
            <>
              <StatCardPercentage icon={{ Icon: DollarSign, color: 'purple' }} title="Vendas Aprovadas" value={fmtCurrencyBR.format(stats.total_revenue)} percentage={stats.conversion_rate} />
              <StatCard icon={{ Icon: TrendingUp, color: 'purple' }} title="Conversão" chart={<Gauge value={stats.conversion_rate} subtitle={`${fmtNumberBR.format(stats.subscriptions)} pagos de ${fmtNumberBR.format(stats.total_payments)}`} />} />

              <StatCard icon={{ Icon: Zap, color: 'purple' }} title="Total de Starts" value={fmtNumberBR.format(stats.bot_starts)} chart={<BotStartsMiniChart data={stats.bot_starts_last_7_days} />} />
              <StatCard icon={{ Icon: PieChart, color: 'purple' }} title="Ticket Médio" value={fmtCurrencyBR.format(stats.avg_ticket)} subtitle={`${fmtNumberBR.format(stats.subscriptions)} Vendas Aprovadas`} />
            </>
          )}
        </div>

        {/* Gráfico + milestone */}
        <div className="dashboard-final" >
          {showSkeleton ? (
            <>
              <SkeletonChart height={550} />
              <SkeletonMilestone />
            </>
          ) : (
            <>
              <RevenueChart
                labels={chart_data.revenue_labels}
                data={chart_data.revenue_data}
                period={period_label}
                total={stats.total_revenue}
              />

              <MilestoneCard milestone={stats.lifetime_milestone} username={user?.username} />
            </>
          )}
        </div>

        <div className="flex flex-col gap-8 justify-between mx-auto md:flex md:flex-row md:items-start" style={{ marginTop: 24 }}>
          <div className='flex-1'>
            <LogsSection logs={stats?.logs || []} loading={loading} fmtDate={fmtDate} />
          </div>
          <div className="ranking-card flex-1">
            <h3><Crown size={16} strokeWidth={2.5} /> Top 5 Codigos de Venda</h3>
            {showSkeleton ? (
              Array(4)
                .fill(0)
                .map((_, i) => <div key={i} className="log-card log-skeleton" />)
            ) : (
              <>
                {stats.top_codigos && stats.top_codigos.length === 0 ? (
                  <div className="log-card">
                    <p>Nenhum código de venda encontrado para o período selecionado.</p>
                  </div>
                ) : (
                  stats.top_codigos.slice(0, 5).map((codigo, idx) => (
                    <RankingItem
                      key={codigo.code || idx}
                      position={idx + 1}
                      name={codigo.code}
                      count={codigo.usage_count}
                      revenue={codigo.revenue}
                    />
                  ))
                )}
              </>
            )}
          </div>
        </div>


      </main>
    </>
  );
}
